import { getColumnsFromMap, sorterDispatcher } from '@app/utils/table'

import { CustomEllipsis } from '@app/constants/customEllipsis'
import { ColumnWidth } from '@app/constants/columnWidth'

import { columnTitleMap } from '../configs'

import type { Column } from '@app/components/base/Table/types'
import type { QuotaReportDirectoryDataSource } from '../types'

const getOptions = (): Array<Column<QuotaReportDirectoryDataSource>> => {
  const columnsKeys = Object.keys(columnTitleMap) as Array<keyof QuotaReportDirectoryDataSource>

  return columnsKeys.map(key => {
    return {
      customEllipsis: CustomEllipsis,
      key,
      sorter: (a, b) => sorterDispatcher(a[key], b[key]),
      ...ColumnWidth
    }
  })
}

export const getColumns = (): Array<Column<QuotaReportDirectoryDataSource>> => {
  return getColumnsFromMap<QuotaReportDirectoryDataSource>({
    columnTitleMap,
    options: [...getOptions()]
  })
}
